/* (ignored) */


//////////////////
// WEBPACK FOOTER
// canvas (ignored)
// module id = 1753
// module chunks = 0